// The browser's side of the shop API: same origin, through naples
// (/shop/api/*), which signs and forwards to bristol. JSON in and out.
const isPreview = () => import.meta.env.VITE_IS_PREVIEW_SERVER === "true";
export const shopApiBase = () => (isPreview() ? "/api/preview/shop/api" : "/shop/api");
export const shopPageApi = () => (isPreview() ? "/api/preview/api/shop-page" : "/api/shop-page");

export class ShopApiError extends Error {
    constructor(status, body) {
        super(body?.error || "Something went wrong");
        this.status = status;
        this.body = body || {};
    }
}

export async function shopApi(path, opts = {}) {
    return (await shopApiWithDate(path, opts)).data;
}

// The same, with the reply's Date header: the server's clock, for a page
// that counts down from a time Bristol gave without its own serverNow.
// A fetch that fails outright is status 0 (the shop can't be reached).
export async function shopApiWithDate(path, {method = "GET", body} = {}) {
    let r;
    try {
        r = await fetch(`${shopApiBase()}${path}`, {
            method,
            headers: body !== undefined ? {"Content-Type": "application/json"} : {},
            body: body !== undefined ? JSON.stringify(body) : undefined,
            credentials: "same-origin",
            cache: "no-store",
        });
    } catch (e) {
        throw new ShopApiError(0, {error: "The shop can't be reached just now"});
    }
    let data = {};
    try { data = await r.json(); } catch (e) { /* empty */ }
    if (!r.ok) throw new ShopApiError(r.status, data);
    return {data, date: r.headers.get("date") || "", receivedAt: Date.now()};
}

export async function fetchShopPage(path) {
    const r = await fetch(`${shopPageApi()}?path=${encodeURIComponent(path)}`, {credentials: "same-origin"});
    if (!r.ok) throw new ShopApiError(r.status, {});
    return r.json();
}
